/* Ganesh product page: gallery, variant picker, quantity, buy box,
   related-products fetch and the offer countdown.
   Framework free, and it hands the cart off to the Maximize drawer when
   that is available, exactly like ganesh-page.js does. */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var STORAGE_KEY = 'gnp:saved-products';

  /* The theme's own xMiniCart.reLoad() calls getSectionsToRender() with no
     section id, and that helper only includes #CartDrawer when it is given
     one — so reLoad refreshes the cart bubble but never the drawer's markup,
     and the drawer opens showing stale (usually empty) content until the page
     is reloaded. The theme's product-form.js sidesteps this by asking for the
     rendered sections in the add request and swapping them in itself, so do
     exactly that. */
  function cartSectionsToRender() {
    var sections = [{ id: 'cart-icon-bubble', selector: '#cart-icon-bubble' }];
    var drawer = document.querySelector('#CartDrawer');
    if (drawer && drawer.dataset.sectionId) {
      sections.push({ id: drawer.dataset.sectionId, selector: '#CartDrawer' });
    }
    return sections;
  }

  function applyCartSections(payload) {
    if (!payload || !payload.sections) return false;
    var swappedDrawer = false;

    cartSectionsToRender().forEach(function (section) {
      var target = document.querySelector(section.selector);
      var html = payload.sections[section.id];
      if (!target || !html) return;

      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      if (!fresh) return;

      target.innerHTML = fresh.innerHTML;
      if (section.selector === '#CartDrawer') swappedDrawer = true;
    });

    return swappedDrawer;
  }

  function refreshThemeCart(payload) {
    var drawerIsFresh = applyCartSections(payload);

    try {
      if (window.Alpine && typeof Alpine.store === 'function') {
        var miniCart = Alpine.store('xMiniCart');
        var cartHelper = Alpine.store('xCartHelper');
        if (cartHelper && typeof cartHelper.updateCurrentCountItem === 'function') {
          cartHelper.updateCurrentCountItem();
        }
        if (miniCart) {
          if (drawerIsFresh) {
            if (typeof miniCart.handleOpen === 'function') miniCart.handleOpen();
          } else if (typeof miniCart.reLoad === 'function') {
            /* could not render the drawer ourselves, let the theme try */
            miniCart.reLoad(true);
          }
        }
      }
    } catch (error) {
      console.warn('[ganesh] cart drawer refresh skipped', error);
    }

    var eventName = (window.CART_EVENT && window.CART_EVENT.cartUpdate) || 'maximize:cart:updated';
    document.dispatchEvent(new CustomEvent(eventName, {
      bubbles: true,
      detail: { isItemCountChanged: true }
    }));
  }

  /* ------------------------------------------------------------- gallery */

  function initGallery(section) {
    var gallery = section.querySelector('[data-gnp-gallery]');
    if (!gallery) return null;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gnp-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gnp-thumb]'));
    if (!slides.length) return null;

    var current = 0;

    function show(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { show(index); });
    });

    var prev = gallery.querySelector('[data-gnp-prev]');
    var next = gallery.querySelector('[data-gnp-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    /* lightbox */
    var zoom = gallery.querySelector('[data-gnp-zoom]');
    var lightbox = section.querySelector('[data-gnp-lightbox]');
    if (zoom && lightbox) {
      var target = lightbox.querySelector('[data-gnp-lightbox-image]');

      function closeLightbox() {
        lightbox.hidden = true;
        document.body.style.overflow = '';
        zoom.focus();
      }

      zoom.addEventListener('click', function () {
        var img = slides[current].querySelector('img');
        if (!img || !target) return;
        target.src = img.dataset.full || img.currentSrc || img.src;
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        var close = lightbox.querySelector('[data-gnp-modal-close]');
        if (close) close.focus();
      });

      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox || event.target.closest('[data-gnp-modal-close]')) closeLightbox();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
      });
    }

    return { show: show };
  }

  /* ------------------------------------------------------- variant picker */

  function initVariants(section, gallery) {
    var form = section.querySelector('[data-gnp-pdp-form]');
    var dataEl = section.querySelector('[data-gnp-variants]');
    if (!form || !dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      console.warn('[ganesh] could not read variant data', error);
      return;
    }
    if (!variants || variants.length < 2) return;

    var buttons = Array.prototype.slice.call(form.querySelectorAll('[data-gnp-value]'));
    if (!buttons.length) return;

    var idField = form.querySelector('[data-gnp-variant-id]');
    var priceEl = section.querySelector('[data-gnp-price]');
    var compareEl = section.querySelector('[data-gnp-compare]');
    var discountEl = section.querySelector('[data-gnp-discount]');
    var badgeEl = section.querySelector('[data-gnp-badge]');
    var atc = form.querySelector('[data-gnp-pdp-atc]');
    var atcLabel = form.querySelector('[data-gnp-atc-label]');
    var buyNow = form.querySelector('[data-gnp-buy-now]');

    function selected() {
      var chosen = [];
      buttons.forEach(function (button) {
        if (button.classList.contains('is-selected')) {
          chosen[parseInt(button.dataset.position, 10) - 1] = button.dataset.value;
        }
      });
      return chosen;
    }

    function match(options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < options.length; j++) {
          if (options[j] !== undefined && v.options[j] !== options[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function apply() {
      var options = selected();
      var variant = match(options);

      /* grey out combinations that do not exist at all */
      buttons.forEach(function (button) {
        var trial = options.slice();
        trial[parseInt(button.dataset.position, 10) - 1] = button.dataset.value;
        var found = match(trial);
        button.classList.toggle('is-unavailable', !found || !found.available);
      });

      var valueLabel = section.querySelector('[data-gnp-option-value="1"]');
      if (valueLabel && options[0]) valueLabel.textContent = options[0];

      if (!variant) {
        if (atc) atc.disabled = true;
        if (buyNow) buyNow.disabled = true;
        if (atcLabel) atcLabel.textContent = atc ? (atc.dataset.soldOutText || 'Sold out') : '';
        return;
      }

      if (idField) idField.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;

      if (compareEl) {
        compareEl.textContent = variant.compare;
        compareEl.hidden = !variant.hasCompare;
      }
      if (discountEl) {
        discountEl.textContent = variant.discount + '% OFF';
        discountEl.hidden = variant.discount <= 0;
      }
      if (badgeEl) {
        badgeEl.textContent = variant.discount + '% OFF';
        badgeEl.hidden = variant.discount <= 0;
      }

      if (atc) {
        atc.disabled = !variant.available;
        if (atcLabel) {
          atcLabel.textContent = variant.available
            ? (atc.dataset.defaultText || atcLabel.dataset.defaultText || atc.dataset.addText || atcLabel.textContent)
            : (atc.dataset.soldOutText || 'Sold out');
        }
      }
      if (buyNow) buyNow.disabled = !variant.available;

      if (gallery && variant.image !== null && variant.image !== undefined) {
        gallery.show(variant.image);
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (error) {
        /* older browser, the form still carries the right id */
      }
    }

    /* remember the original add-to-cart wording so it can come back */
    if (atc && atcLabel) atc.dataset.defaultText = atcLabel.textContent.trim();

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (other) {
          if (other.dataset.position === button.dataset.position) {
            other.classList.remove('is-selected');
            other.setAttribute('aria-pressed', 'false');
          }
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        apply();
      });
    });

    apply();
  }

  /* ------------------------------------------------------------ quantity */

  function initQuantity(section) {
    var input = section.querySelector('[data-gnp-qty-input]');
    if (!input) return;

    section.querySelectorAll('[data-gnp-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = parseInt(button.dataset.gnpQty, 10) || 0;
        var value = (parseInt(input.value, 10) || 1) + step;
        input.value = Math.max(1, value);
      });
    });

    input.addEventListener('change', function () {
      var value = parseInt(input.value, 10);
      if (!value || value < 1) input.value = 1;
    });
  }

  /* ------------------------------------------------------------- buy box */

  /* Picks up any properties[Name] style field in the form (the buyer name /
     phone inputs today, whatever else gets added later) so it rides along
     as a real Shopify line item property, the same thing that shows up in
     the cart, on checkout, and on the order in admin. */
  function collectLineItemProperties(form) {
    var properties = {};
    Array.prototype.slice.call(form.querySelectorAll('[name^="properties["]')).forEach(function (input) {
      var match = input.name.match(/^properties\[(.+)\]$/);
      if (!match) return;
      var value = (input.value || '').trim();
      if (value) properties[match[1]] = value;
    });
    return properties;
  }

  function addToCart(form) {
    var idField = form.querySelector('[data-gnp-variant-id]');
    var qtyField = form.querySelector('[name="quantity"]');
    var properties = collectLineItemProperties(form);
    var item = {
      id: idField.value,
      quantity: parseInt(qtyField && qtyField.value, 10) || 1
    };
    if (Object.keys(properties).length) item.properties = properties;

    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [item],
        sections: cartSectionsToRender().map(function (section) { return section.id; })
      })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    });
  }

  function initBuyBox(section) {
    var form = section.querySelector('[data-gnp-pdp-form]');
    if (!form) return;

    var note = form.querySelector('[data-gnp-note]');
    var atc = form.querySelector('[data-gnp-pdp-atc]');
    var atcLabel = form.querySelector('[data-gnp-atc-label]');
    var buyNow = form.querySelector('[data-gnp-buy-now]');

    function say(message, kind) {
      if (!note) return;
      note.textContent = message;
      note.className = 'gnp-pdp__note' + (kind ? ' gnp-pdp__note--' + kind : '');
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!atc || atc.disabled || atc.classList.contains('is-loading')) return;

      var original = atcLabel ? atcLabel.textContent : '';
      atc.classList.add('is-loading');
      if (atcLabel) atcLabel.textContent = atc.dataset.addingText || 'Adding...';
      say('');

      addToCart(form)
        .then(function (payload) {
          say(atc.dataset.addedText || 'Added to cart', 'success');
          refreshThemeCart(payload);
        })
        .catch(function (error) { say(error.message, 'error'); })
        .finally(function () {
          atc.classList.remove('is-loading');
          if (atcLabel) atcLabel.textContent = original;
        });
    });

    if (buyNow) {
      buyNow.addEventListener('click', function () {
        if (buyNow.disabled || buyNow.classList.contains('is-loading')) return;
        /* Buy Now is type="button", so it skips the browser's own required-field
           check that the Add to Cart submit button gets for free. */
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        buyNow.classList.add('is-loading');
        say('');

        addToCart(form)
          .then(function () { window.location.href = ROOT + 'checkout'; })
          .catch(function (error) {
            say(error.message, 'error');
            buyNow.classList.remove('is-loading');
          });
      });
    }
  }

  /* ------------------------------------------------------- saved (hearts) */

  function bindHearts(scope) {
    var saved = [];
    try {
      saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) { saved = []; }

    scope.querySelectorAll('[data-gnp-wish]').forEach(function (button) {
      if (button.dataset.gnpWishBound === 'true') return;
      button.dataset.gnpWishBound = 'true';
      button.setAttribute('aria-pressed', saved.indexOf(button.dataset.gnpWish) > -1 ? 'true' : 'false');

      button.addEventListener('click', function () {
        var list = [];
        try {
          list = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
        } catch (error) { list = []; }

        var index = list.indexOf(button.dataset.gnpWish);
        if (index > -1) {
          list.splice(index, 1);
          button.setAttribute('aria-pressed', 'false');
        } else {
          list.push(button.dataset.gnpWish);
          button.setAttribute('aria-pressed', 'true');
        }
        try {
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
        } catch (error) { /* private browsing */ }
      });
    });
  }

  /* -------------------------------------------------- related products */

  function initRelated(section) {
    var url = section.dataset.gnpRecommendations;
    var grid = section.querySelector('[data-gnp-related-grid]');
    if (!url || !grid || grid.children.length > 0) return;

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-gnp-related-grid]');
        if (!fresh || !fresh.children.length) {
          section.hidden = true;
          return;
        }
        grid.innerHTML = fresh.innerHTML;
        bindHearts(grid);
        /* the page-load carousel pass found this track empty and skipped
           it, so wire up its arrows/dots now that cards actually exist */
        if (typeof window.GaneshInitCarousels === 'function') {
          window.GaneshInitCarousels(section);
        }
      })
      .catch(function (error) {
        console.warn('[ganesh] recommendations failed', error);
        section.hidden = true;
      });
  }

  /* ------------------------------------------------------------ countdown */

  function initCountdown(section) {
    var el = section.querySelector('[data-gnp-countdown]');
    if (!el) return;

    var raw = (el.dataset.gnpCountdown || '').trim();
    if (!raw) return;

    /* "2026-09-06 23:59" needs the T for Safari; anything already ISO passes through */
    var normalised = raw.indexOf('T') === -1 ? raw.replace(' ', 'T') : raw;
    var end = new Date(normalised).getTime();
    if (isNaN(end)) {
      console.warn('[ganesh] countdown date could not be read:', raw);
      return;
    }

    var fields = {
      days: el.querySelector('[data-gnp-days]'),
      hours: el.querySelector('[data-gnp-hours]'),
      minutes: el.querySelector('[data-gnp-minutes]'),
      seconds: el.querySelector('[data-gnp-seconds]')
    };
    var ended = section.querySelector('[data-gnp-countdown-ended]');
    var timer;

    function pad(value) { return value < 10 ? '0' + value : String(value); }

    function tick() {
      var left = end - Date.now();

      if (left <= 0) {
        window.clearInterval(timer);
        el.hidden = true;
        if (ended) {
          ended.textContent = el.dataset.endedText || 'This offer has ended.';
          ended.hidden = false;
        }
        return;
      }

      var seconds = Math.floor(left / 1000);
      if (fields.days) fields.days.textContent = pad(Math.floor(seconds / 86400));
      if (fields.hours) fields.hours.textContent = pad(Math.floor(seconds % 86400 / 3600));
      if (fields.minutes) fields.minutes.textContent = pad(Math.floor(seconds % 3600 / 60));
      if (fields.seconds) fields.seconds.textContent = pad(seconds % 60);
    }

    tick();
    timer = window.setInterval(tick, 1000);
  }

  /* ---------------------------------------------------------------- boot */

  function init(scope) {
    var sections = Array.prototype.slice.call((scope || document).querySelectorAll('[data-gnp-section]'));
    sections.forEach(function (section) {
      if (section.dataset.gnpPdpReady === 'true') return;
      section.dataset.gnpPdpReady = 'true';

      var gallery = initGallery(section);
      initVariants(section, gallery);
      initQuantity(section);
      initBuyBox(section);
      initRelated(section);
      initCountdown(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
